import React from "react";
import { Typography } from "common/components/Typography";
import { IconBadge } from "common/components/map/IconBadge";
import FloodOutlinedIcon from "@mui/icons-material/FloodOutlined";
import colors from "common/styles/colors";
import {
  ClimateRiskType,
  PropertyFloodRisk,
} from "../../types/appraiser.types";
import { ClimateRiskTypesTranslations } from "../../helpers/comparableFields.helpers";
import { determineBackgroundColor } from "../../helpers/climateRisk.helpers";
import { PropertyLocationMap } from "./PropertyLocationMap";
import {
  PropertyLocationDetailsType,
  PropertyLocationDetails,
} from "../../types/api.types";
import { PropertyClimateRiskWrapper } from "./PropertyClimateRiskWrapper";
import { FloodZoneCriteria } from "./FloodZoneCriteria";

interface PropertyFloodRiskContentProps {
  floodRisk?: PropertyFloodRisk;
  locations: PropertyLocationDetails[];
  onRegenerate?: () => void;
}

export const PropertyFloodRiskContent: React.FC<
  PropertyFloodRiskContentProps
> = ({ floodRisk, locations, onRegenerate }) => {
  const floodThreatLayerLocation = locations.find(
    (location) => location.locationType === PropertyLocationDetailsType.FLOODS
  );

  const floodRiskLayerLocation = locations.find(
    (location) =>
      location.locationType === PropertyLocationDetailsType.FLOOD_RISK
  );

  return (
    <div
      style={{
        marginTop: "25px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <PropertyClimateRiskWrapper
        title={<Typography variant="h5">Potvynių rizika</Typography>}
        description={
          <Typography variant="caption">
            Vertinama pagal vandens telkinių artumą ir jų galimą poveikį
            teritorijai.
          </Typography>
        }
        icon={
          <IconBadge
            width={40}
            height={40}
            backgroundColor={
              floodRisk?.floodRisk &&
              Object.values(ClimateRiskType).includes(floodRisk.floodRisk)
                ? determineBackgroundColor(floodRisk.floodRisk)
                : colors.grey
            }
          >
            <FloodOutlinedIcon fontSize="medium" style={{ color: "white" }} />
          </IconBadge>
        }
        riskType={
          <Typography variant="h4">
            {floodRisk?.floodRisk &&
            Object.values(ClimateRiskType).includes(floodRisk.floodRisk)
              ? ClimateRiskTypesTranslations[floodRisk.floodRisk]
              : "Nežinoma"}
          </Typography>
        }
        riskDescription={
          floodRisk?.floodRisk &&
          Object.values(ClimateRiskType).includes(floodRisk.floodRisk) ? (
            <FloodZoneCriteria floodRisk={floodRisk.floodRisk} />
          ) : (
            <Typography variant="caption">Potvynio rizika nežinoma.</Typography>
          )
        }
      />
      <div style={{ display: "flex", flexDirection: "column", width: "45%" }}>
        {!!floodThreatLayerLocation && (
          <div>
            <PropertyLocationMap
              locationDetails={floodThreatLayerLocation}
              onRegenerate={onRegenerate}
              printableView={!onRegenerate}
            />
          </div>
        )}

        {!!floodRiskLayerLocation && (
          <div>
            <PropertyLocationMap
              locationDetails={floodRiskLayerLocation}
              onRegenerate={onRegenerate}
              printableView={!onRegenerate}
            />
          </div>
        )}
      </div>
    </div>
  );
};
